// Core exports
export { createHttpClient } from "./http";
export type {
  HttpClient,
  HttpClientConfig,
  HttpRequestConfig,
  HttpRequestConfigWithSchema,
  HttpRequestConfigWithHeaders,
  HttpRequestConfigWithSchemaAndHeaders,
  HttpResponse,
} from "./http";
export { HttpError, ValidationError, NetworkError } from "./errors";
export type {
  ApiResponse,
  DataAndMessageResponse,
  MessageResponse,
} from "./types";

// Asset type re-exports
export type {
  AssetResponse,
  UserAssetGroup,
  AssetListResponse,
  CreateAssetDto,
  UpdateAssetDto,
  AssetSnapshotChartQuery,
} from "./modules/asset";

// Storage type re-exports
export type {
  PresignedUrlResponse,
  MultipartUploadInitResponse,
  PresignedPartUrl,
  CompleteMultipartUploadResponse,
  FilePart,
} from "./modules/storage";

// Push type re-exports
export type { VapidPublicKeyResponse } from "./modules/push";

// Module factories
import { createLogModule } from "./modules/log";
import { createWorkspaceModule } from "./modules/workspace";
import { createUserModule } from "./modules/user";
import { createCategoryModule } from "./modules/category";
import { createMethodModule } from "./modules/method";
import { createAdjustmentModule } from "./modules/adjustment";
import { createSpendingGoalModule } from "./modules/spending-goal";
import { createNotificationModule } from "./modules/notification";
import { createNotificationSettingModule } from "./modules/notification-setting";
import { createInvitationModule } from "./modules/invitation";
import { createStatsModule } from "./modules/stats";
import { createPushModule } from "./modules/push";
import { createStorageModule } from "./modules/storage";
import { createAssetModule } from "./modules/asset";

import type { HttpClient } from "./http";

export function createApiModules(httpClient: HttpClient) {
  return {
    log: createLogModule(httpClient),
    workspace: createWorkspaceModule(httpClient),
    user: createUserModule(httpClient),
    category: createCategoryModule(httpClient),
    method: createMethodModule(httpClient),
    adjustment: createAdjustmentModule(httpClient),
    spendingGoal: createSpendingGoalModule(httpClient),
    notification: createNotificationModule(httpClient),
    notificationSetting: createNotificationSettingModule(httpClient),
    invitation: createInvitationModule(httpClient),
    stats: createStatsModule(httpClient),
    push: createPushModule(httpClient),
    storage: createStorageModule(httpClient),
    asset: createAssetModule(httpClient),
  };
}

export type ApiModules = ReturnType<typeof createApiModules>;
